export enum FeedbackType {
  BUG = "Bug",
  QUESTION = "Question",
  SUGGESTION = "Suggestion",
}
